export const SET_NAME = (state, value) => {
  state.name = value
}

export const SET_EMAIL = (state, value) => {
  state.email = value
}

export const COPY_FORM = (state, value) => {
  state[value.original].form = Object.assign({}, state[value.toCopy].form)
}

export const SAVE_DELEGATION = (state, value) => {
  state.delegation = value
}

export const SET_LANGUAGE = (state, value) => {
  state.language = value
}

const restored = () => {
  return {
    email: undefined,
    emited: 1,
    read: 1,
    accepted: 1,
    refused: 1,
    edited: 1,
    ignored: 1,
    language: 1
  }
}

export const CLEAN_FORMS = (state) => {
  state.billToCharge.form = restored()
  state.billToPay.form = restored()
  state.autoBillToCharge.form = restored()
  state.autoBillToPay.form = restored()
}

export const SET_UP_FORMS = (state, {key, value}) => {
  for (var prop in value) {
    state[key].form[prop] = value[prop]
  }
}

export const SET_AVAILABLE_DELEGATIONS = (state, delegations) => {
  state.availableDelegations = delegations
}

export const SET_LOADED = (state, value) => {
  state.loaded = value
}
